<div class="settings-container">
  <ul ngbNav #nav="ngbNav" [(activeId)]="activeTab" class="nav-tabs">
    <li *ngIf="analyticsEnabled && canManageSettings" [ngbNavItem]="1">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Analysis' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-analysis-settings></ca-analysis-settings>
      </ng-template>
    </li>
    <li *ngIf="analyticsEnabled && canManageSettings && speechRecognitionEnabled" [ngbNavItem]="2">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'SpeechRecognition::SpeechRecognitionAgentTraining' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-speech-recognition-settings></ca-speech-recognition-settings>
      </ng-template>
    </li>
    <li *ngIf="analyticsEnabled && canManageSettings" [ngbNavItem]="3">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::UserDefinedCategoriesSettings' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-user-defined-category-settings></ca-user-defined-category-settings>
      </ng-template>
    </li>
    <li *ngIf="analyticsEnabled && canManageSettings && premiumReportsEnabled" [ngbNavItem]="4">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Analytics:PremiumReports' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ng-container *ngComponentOutlet="premiumReportsComponent"></ng-container>
      </ng-template>
    </li>
    <li *ngIf="analyticsEnabled && isSuperAdminUser" [ngbNavItem]="5">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::AnalyticsFeatures:SettingsLabel' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-analytics-features-settings></ca-analytics-features-settings>
      </ng-template>
    </li>
    <li
      *ngIf="analyticsEnabled && canManageSettings && namedEntityRecognitionEnabled"
      [ngbNavItem]="6">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::NamedEntityRecognition' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-named-entity-recognition-settings></ca-named-entity-recognition-settings>
      </ng-template>
    </li>
    <li *ngIf="analyticsEnabled && canManageSettings" [ngbNavItem]="7">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::ConversationDurationRanges' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-conversation-duration-range-settings></ca-conversation-duration-range-settings>
      </ng-template>
    </li>
    <li [ngbNavItem]="8">
      <a ngbNavLink>
        <span style="margin-left: 4px">
          {{ 'Settings::Definitions' | abpLocalization }}
        </span>
      </a>
      <ng-template ngbNavContent>
        <ca-setting-definitions
          [information]="'Settings::SettingsDefinitionInfo'"
          [items]="settingsDefinitionItems"></ca-setting-definitions>
      </ng-template>
    </li>
  </ul>
  <div [ngbNavOutlet]="nav"></div>
</div>
